<template>
  <div class="page-container">
    <van-nav-bar left-arrow fixed :z-index="10" @click-left="goableBack()" :title="protocol.title"></van-nav-bar>
    <div v-if="protocol.type === 'html'" class="content" v-html="protocol.content"></div>
    <div v-else-if="protocol.type === 'hpdf'">
      <div class="content" v-html="protocol.content"></div>
    </div>
    <div v-else-if="numPages > 0">
      <pdf v-for="item in numPages" :key="item" :src="src" :page="item" />
    </div>
    <div v-else>
      <iframe v-if="protocol.content" :src="protocol.content" hight="auto" width="100%" frameborder="0" scrolling="auto" onload="this.height=1000"></iframe>
    </div>
  </div>
</template>

<script>
import { investNewprotocol } from "@/api/pay"
import { NavBar, Toast } from "vant"
import pdf from "vue-pdf-sign"
import CMapReaderFactory from "vue-pdf-sign/src/CMapReaderFactory.js"
import { getAuctionConfirmFile, getAuctionProtocol } from "../../api/product"
import storage from "../../utils/storage"
export default {
  name: "trade",
  metaInfo: {
    title: "trade",
    meta: [
      { charset: "utf-8" },
      {
        name: "viewport",
        content:
          "width=width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes"
      }
    ]
  },

  data: () => ({
    id: "",
    productId: "",
    type: "",
    tradeAmount: "",
    src: "",
    numPages: 0,
    protocol: {},
    currentPage: 1, // 当前页码
    pageCount: 0, // 总页码
    pushType: 1 // 显示协议的类型：1 查看协议 2 拍卖资产协议 3 拍卖资产确认书
  }),
  beforeMount() {
    this.pushType = this.$route.query.pushType
    this.id = this.$route.query.id || ""
    this.productId = this.$route.query.productId || ""
    this.tradeAmount = this.$route.query.tradeAmount || ""
    this.type = this.$route.query.type || ""
    if (this.id || this.productId) {
      this.fetch()
    }
  },
  methods: {
    loadPdfHandler() {
      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages
      })
    },
    fetch() {
      this._showLoading()
      if (this.pushType == 2) {
        let baseUrl =
          location.href.split("#")[0] +
          (process.env.NODE_ENV === "production" ? "api/" : "test-api/")
        let url =
          baseUrl +
          "product/getAuctionProtocol?productId=" +
          this.productId +
          "&id=" +
          this.id +
          "&tradeAmount=" +
          this.tradeAmount +
          "&type=" +
          this.type +
          "&token=" +
          storage.get("app-token")
        this.protocol = { title: this.$route.query.title, content: url }
        this.src = pdf.createLoadingTask({
          url: this.protocol.content,
          CMapReaderFactory
        })
        this.loadPdfHandler()
        this._dismissLoading()
        /*
        getAuctionProtocol(this.productId, this.id, this.tradeAmount, this.type)
          .then((data) => {
            this.protocol = data
            this.src = pdf.createLoadingTask({
              url: this.protocol,
              CMapReaderFactory
            })
            this.loadPdfHandler()
            this._dismissLoading()
          })
          .catch((e) => {
            this._dismissLoading()
            Toast(e.msg || e.message)
          })*/
      } else if (this.pushType == 3) {
        getAuctionConfirmFile(this.productId)
          .then((data) => {
            this.protocol = { title: this.$route.query.title, content: data }
            this.src = pdf.createLoadingTask({
              url: this.protocol.content,
              CMapReaderFactory
            })
            this.loadPdfHandler()
            this._dismissLoading()
          })
          .catch((e) => {
            this._dismissLoading()
            Toast(e.msg || e.message)
          })
      } else {
        let data = {
          investId: this.id,
          mark: "CK"
        }
        investNewprotocol(data)
          .then((data) => {
            this.protocol = data
            if (this.$route.query.title) {
              this.protocol.title = this.$route.query.title
            }
            if (this.protocol.content) {
              this.src = pdf.createLoadingTask({
                url: this.protocol.content,
                CMapReaderFactory
              })
              this.loadPdfHandler()
            } else {
              this.$toast("")
            }

            this._dismissLoading()
          })
          .catch((e) => {
            this._dismissLoading()
            Toast(e.msg || e.message)
          })
      }
    }
  },
  components: {
    pdf,
    [NavBar.name]: NavBar,
    [Toast.name]: Toast
  }
}
</script>
    
<style lang="less" scoped>
.content {
  padding: 20px;
}
.van-nav-bar {
  background: #fff;

  .van-nav-bar__title {
    color: @dark;
  }
  .van-icon {
    color: @dark !important;
  }
}
</style>
